import * as styles from './styles/legacy';
export { default as VisualPicker } from './react/VisualPicker';
export { Styled } from './react/VisualPicker.styled';
export { default as processSelection } from './utils/processSelection';
export { styles };
